module.exports = function (color) {
    return `<?xml version="1.0"?>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><circle r="256" cx="256" cy="256" fill="${color}" shape="circle"/><g transform="matrix(0.58,0,0,0.58,107.52000097788871,107.52000000000001)">
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M352,216c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S357.52,216,352,216z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M120,216c-5.52,0-10,4.48-10,10s4.48,10,10,10s10-4.48,10-10S125.52,216,120,216z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M382,106H135.03c-50.924,0-93.534,39.121-94.985,87.208C38.507,244.104,79.179,286,130,286h59.27    c4.533,0,8.499-3.049,9.664-7.43l2.919-10.973C208.387,243.105,230.652,226,256,226s47.613,17.105,54.146,41.59l2.921,10.98    c1.165,4.381,5.131,7.43,9.664,7.43h54.239c50.924,0,93.534-39.121,94.985-87.208C473.493,147.896,432.821,106,382,106z     M451.965,198.188C450.836,235.58,417.193,266,376.97,266h-46.552l-0.946-3.559C320.605,229.21,290.394,206,256,206    c-34.394,0-64.605,23.21-73.474,56.449L181.582,266H130c-39.367,0-71.164-32.422-69.965-72.188    C61.164,156.42,94.807,126,135.03,126H382C421.367,126,453.164,158.422,451.965,198.188z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M492,126.75V10c0-5.522-4.478-10-10-10h-60c-5.522,0-10,4.478-10,10v59.483C402.215,67.169,392.172,66,382,66H135.03    C63.859,66,2.198,120.896,0.064,192.01C-2.144,265.528,56.639,326,130,326h74.63c13.567,0,25.489-9.157,28.992-22.272l6.89-25.829    C242.381,270.893,248.75,266,256,266c7.418,0,13.655,5.027,15.488,11.897l6.891,25.834C281.881,316.843,293.803,326,307.37,326    h69.6c11.884,0,23.618-1.528,35.03-4.535V382c0,16.519-13.402,30-30,30h-57.72c-4.128-11.639-15.243-20-28.28-20h-80    c-13.036,0-24.152,8.361-28.28,20H136c-5.522,0-10,4.478-10,10v60c0,5.522,4.478,10,10,10h51.72c4.128,11.639,15.243,20,28.28,20    h80c13.036,0,24.152-8.361,28.28-20H392c55.166,0,100-44.708,100-100V263.947c12.379-19.251,19.258-41.27,19.936-63.956    C512.721,173.874,505.821,148.625,492,126.75z M186,472h-40v-40h40V472z M306,482c0,5.514-4.486,10-10,10h-80    c-5.514,0-10-4.486-10-10v-60c0-5.514,4.486-10,10-10h80c5.514,0,10,4.486,10,10V482z M372,472h-46v-40h46V472z M432,20h40v82.27    c-11.589-11.111-25.186-20.075-40-26.271V20z M392,472v-40.999c6.283-1.27,12.232-3.735,17.575-7.284l31.473,31.473    C427.083,466.078,410.005,472,392,472z M455.19,441.047l-31.475-31.475c2.195-3.307,3.976-6.952,5.316-10.673h42.651    C470.356,414.312,464.656,428.904,455.19,441.047z M472,379h-40v-64.493c14.809-6.444,28.416-15.48,40-26.487V379z     M491.945,199.392c-1.362,45.584-32.121,83.72-73.894,99.206C404.857,303.51,391.035,306,376.97,306h-69.6    c-4.524,0-8.5-3.056-9.668-7.427l-6.89-25.83C286.686,257.275,272.65,246,256,246c-16.295,0-30.61,10.996-34.813,26.743    l-6.889,25.826c-1.169,4.375-5.145,7.431-9.669,7.431H130c-61.989,0-111.814-51.074-109.945-113.391    C21.819,133.825,73.396,86,135.03,86H382C443.842,86,493.816,137.087,491.945,199.392z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M276,432h-40c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h40c5.522,0,10-4.478,10-10C286,436.478,281.522,432,276,432    z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M187.072,158.929c-3.907-3.905-10.237-3.905-14.143,0l-30,30c-3.905,3.905-3.905,10.237,0,14.143    c3.907,3.905,10.236,3.904,14.143,0l30-30C190.977,169.167,190.977,162.835,187.072,158.929z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M419.072,158.929c-3.907-3.905-10.237-3.905-14.143,0l-30,30c-3.905,3.905-3.905,10.237,0,14.143    c3.907,3.905,10.236,3.904,14.143,0l30-30C422.977,169.167,422.977,162.835,419.072,158.929z" fill="#ffffff" data-original="#000000" style="" class=""/>
        </g>
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    <g xmlns="http://www.w3.org/2000/svg">
    </g>
    </g></svg>
    `
}